import { useHistory, useLocation } from 'react-router-dom'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { Card } from '@mui/material'
import { FaArrowLeft } from 'react-icons/fa'
import LogoNevula from '../../assets/images/logo-only-blue.svg'

export const IndividualItemView = () => {
  const location = useLocation()
  const data = location.state as any

  const history = useHistory()

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
          <FaArrowLeft style={{color: '#2961D0'}} onClick={() => history?.push("/inventory")} />

        <img src={LogoNevula} alt="zerux" style={{height: 35, width: 35}} />
      </div>

      <div className="flex justify-center mt-5">
        <img
          src={data?.image || placeholder}
          style={{ width: '80%', height: 300, borderRadius: 6 }}
        />
      </div>

      <div className="mt-3">
        <label style={{ color: '#2961D0', fontSize: 20 }} className="font-bold">
          {data?.name}
        </label>
      </div>

      <div className="mt-4">
        <Card className="p-3">
          <div>
            <label>
              <strong>Costo:</strong> ${data?.cost}
            </label>
          </div>
          <div>
            <label>
              <strong>Precio unitario:</strong> ${(+data?.price).toFixed(2)}
            </label>
          </div>
          <div>
            <label>
              <strong>Existencia:</strong> {data?.totalQuantity} unidades
            </label>
          </div>

          <div>
            <label>
              <strong>Categoría:</strong> {data?.category?.name}
            </label>
          </div>
        </Card>
      </div>
    </div>
  )
}
